import React, { useEffect, useState } from 'react';
import '../styles/AnimatedBackground.css';

const AnimatedBackground = ({ type = 'default' }) => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        // Set loaded to true after component mounts to trigger animations
        setLoaded(true);

        // Clean up function
        return () => {
            setLoaded(false);
        };
    }, []);

    return (
        <div className={`animated-background ${type}-bg ${loaded ? 'loaded' : ''}`}>
            <div className="animated-overlay"></div>
            <div className="animated-particles">
                {[...Array(20)].map((_, i) => (
                    <div
                        key={i}
                        className="animated-particle"
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                            animationDelay: `${Math.random() * 5}s`,
                            animationDuration: `${10 + Math.random() * 20}s`,
                            opacity: 0.1 + Math.random() * 0.4,
                            width: `${5 + Math.random() * 10}px`,
                            height: `${5 + Math.random() * 10}px`
                        }}
                    ></div>
                ))}
            </div>
        </div>
    );
};

export default AnimatedBackground;
